import React from 'react';
import Button from '@mui/material/Button';
import Modal from '@/common/components/Modal/index';
import styles from '@/common/containers/TaskDetails/styles.less';
import { ReactBB } from '@/common/utils/index';
import { useTranslation } from 'react-i18next';

const InfoModal = ({ open, onClose, data = '' }) => {
  const { t } = useTranslation();
  return (
    <Modal className={styles.infoModal} open={open} onClose={onClose} overlay>
      <div className={styles.infoModalHeader}>{t('Additional info')}</div>
      <div className={styles.infoModalBody}>{ReactBB(data)}</div>
      <div className={styles.infoModalFooter}>
        <Button variant="contained" color="success" onClick={onClose}>
          {t('Close')}
        </Button>
      </div>
    </Modal>
  );
};

export default InfoModal;
